// extracted by mini-css-extract-plugin
export default {"intro-wrapper":"CompanyIntro_intro-wrapper__tpH4W","logo":"CompanyIntro_logo__ZWFlS","description":"CompanyIntro_description__rJQNW"};